import { useState, useEffect } from 'react';
import { toDataURL } from 'qrcode';
import FlyImage from './FlyImage';
import FlyError from './FlyError';

interface QrCodeProps {
  payload: string;
}

function QrCode({ payload }: QrCodeProps) {
  const [qrCode, setQrCode] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    (async () => {
      try {
        const qrCodeImage = await toDataURL(payload);
        setQrCode(qrCodeImage);
      } catch (error) {
        setErrorMessage(
          error instanceof Error
            ? `QrCode: ${error.message}`
            : 'QrCode: Cannot get qr-code image',
        );
      }
    })();
  }, [payload]);

  return (
    <>
      {qrCode && (
        <FlyImage
          src={qrCode}
          alt="Deposit address qr-code"
          sx={{ width: '100%', maxWidth: '15rem', borderRadius: '10px' }}
        />
      )}
      <FlyError errorMessage={errorMessage} setErrorMessage={setErrorMessage} />
    </>
  );
}

export default QrCode;
